import React, { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import TrapSiteForm from "./TrapSiteForm";
import validateForm from "./TrapSiteValidation";
import { useWebServer } from "../../../../../providers";
import { useHistory } from "react-router-dom";
import ROUTES from "../../../../AppRouter/routes";
import { editTrapSite } from "../../../../../actions";
import { countyForSave } from "./TrapSiteForm/countyPayload";
import { useSiteGroups } from "../SiteGroups/useSiteGroups";
import { SiteGroupsField } from "../SiteGroups/SiteGroupsField";
import { newReportsEnabled } from "../../../../../utils/features";

const TrapSiteEdit = ({ trapSiteId, sitesLoaded, editTrapSite, ...otherProps }) => {
  const { sendRequest } = useWebServer();
  const history = useHistory();
  const { initialize, initialValues } = otherProps
  const siteGroups = useSiteGroups({ enabled: newReportsEnabled() });
  // the groups this site is in, as loaded; null until the user changes them
  const memberOf = useMemo(
    () => siteGroups.groups.filter((g) => g.trapSiteIds.map(String).includes(String(trapSiteId))).map((g) => g.id),
    [siteGroups.groups, trapSiteId]
  );
  const [groupIds, setGroupIds] = useState(null);
  const groupsChanged =
    groupIds !== null && [...groupIds].sort().join() !== [...memberOf].sort().join();


  // Opened from a link or a reload, the site list is still loading on mount:
  // fill the form once it arrives, and only give up on a site that is not in
  // the loaded list.
  useEffect(() => {
    initialize(initialValues)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trapSiteId, sitesLoaded]);

  useEffect(() => {
    if (sitesLoaded && _.isEmpty(otherProps.initialValues)) {
      history.push(ROUTES.trapSite);
    }
  }, [history, sitesLoaded, otherProps?.initialValues]);
  const onSave = async ({ county, ...trapSite }) => {
    const countyChange = countyForSave(county, initialValues?.county);
    await editTrapSite(
      trapSiteId,
      countyChange === undefined ? trapSite : { ...trapSite, county: countyChange },
      sendRequest
    );
    if (groupsChanged) await siteGroups.setSiteGroups(trapSiteId, groupIds);
    history.push(ROUTES.trapSite);
  };

  return (
      <TrapSiteForm
        {...otherProps}
        onSave={onSave}
        extraDirty={groupsChanged}
        extraFields={
          newReportsEnabled() && (
            <SiteGroupsField
              groups={siteGroups.groups}
              value={groupIds ?? memberOf}
              onChange={setGroupIds}
              disabled={siteGroups.loading}
            />
          )
        }
      />
  );
};

const mapStateToProps = (state, ownProps) => {
  const trapSiteId = ownProps.match.params.id;
  const initialValues = _.pick(
    state.trapSites[trapSiteId],
    "displayName",
    "description",
    "address",
    "gpsLocation",
    "county"
  );
  if (initialValues?.gpsLocation) {
    const { latitude, longitude } = initialValues.gpsLocation;
    initialValues.gpsLocation = `${latitude} ${longitude}`;
  }
  return {
    trapSiteId,
    // FETCH_TRAP_SITES sets count, so its presence means the list has loaded
    sitesLoaded: state.trapSites?.count !== undefined,
    initialValues,
    countySource: state.trapSites[trapSiteId]?.countySource,
  };
};

const formWrapped = reduxForm({
  form: "TrapSiteEdit",
  validate: validateForm,
})(TrapSiteEdit);

export default connect(mapStateToProps, { editTrapSite })(formWrapped);
